import { Link } from "react-router-dom"
import { FaArrowRight } from "react-icons/fa"

export default function CategoryCard({ category }) {
return (
<article className="group overflow-hidden rounded-2xl bg-white shadow-sm hover:shadow-xl transition-all duration-300">

  <Link
    to={`/categories/${category.slug}`}
    className="block"
    aria-label={category.name}
  >
    {/* Image */}
    <div className="relative overflow-hidden">
      <img
        src={category.image}
        alt={category.name}
        loading="lazy"
        className="w-full h-72 object-cover group-hover:scale-110 transition-transform duration-700"
      />

      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />

      {/* Nombre de produits */}
      {category.productCount > 0 && (
        <span className="absolute top-4 right-4 bg-white/95 backdrop-blur px-3 py-1 rounded-full text-sm font-medium text-gray-900">
          {category.productCount} produits
        </span>
      )}
    </div>

    {/* Content */}
    <div className="p-6">

      <h3 className="text-xl font-bold text-gray-900 group-hover:text-blue-600 transition-colors">
        {category.name}
      </h3>

      {category.description && (
        <p className="mt-3 text-gray-600 leading-relaxed line-clamp-2">
          {category.description}
        </p>
      )}

      <div className="mt-5 inline-flex items-center gap-2 text-blue-600 font-semibold group-hover:gap-3 transition-all">
        Découvrir
        <FaArrowRight size={12} />
      </div>

    </div>
  </Link>

</article>

)
}